export default function (chassi) {
  const sanitizedChassi = chassi.toUpperCase()
    .replace(/I/g, '1')
    .replace(/[OQ]/g, '0')
    .replace(/[^1234567890ABCDEFGHJKLMNPRSTUVWXYZ]/g, '')
  const textManipulated = new RegExp(/[^1234567890ABCDEFGHJKLMNPRSTUVWXYZ]/g).test(chassi.toUpperCase())
  return { chassi: sanitizedChassi, manipulated: textManipulated }
}
